import { render, staticRenderFns } from "./PrenotazioniAdvanced.vue?vue&type=template&id=12196e02&scoped=true&"
import script from "./PrenotazioniAdvanced.vue?vue&type=script&lang=js&"
export * from "./PrenotazioniAdvanced.vue?vue&type=script&lang=js&"
import style0 from "./PrenotazioniAdvanced.vue?vue&type=style&index=0&id=12196e02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12196e02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Repository/SprayerManager_WebSite/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VPagination } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VFlex,VIcon,VLayout,VPagination})
